(function () {
    if (!document.getElementById('chipsLabel')) return;
    document.getElementById('chipsLabel').addEventListener('click', function () {
        this.classList.toggle('active');
    });
})();